import { getWebInstrumentations, initializeFaro } from '@grafana/faro-web-sdk'
import { TracingInstrumentation } from '@grafana/faro-web-tracing'

initializeFaro({
  url: 'https://faro-collector-prod-us-east-2.grafana.net/collect/28d88754a96f0d29353183d2d7ec4438',
  app: {
    name: 'CraftyWeb',
    version: '1.0.0',
    environment: window.GRAFANA_ENVIRONMENT,
  },

  instrumentations: [
    ...getWebInstrumentations(),
    new TracingInstrumentation(),
  ],
})
